import { useColorMode } from '@vueuse/core'
import { ref } from 'vue'

const { store } = useColorMode({
    initialValue: 'light',
    storageKey: 'msig-color-theme'
})
const modeModelValue = ref(false)

export const initMsigColorMode = () => {
    // If system is dark, and store has nothing
    // if (system.value === 'dark' && store.value === 'auto') {
    //     store.value = 'light'
    //     modeModelValue.value = false
    // }

    if (store.value === 'light') {
        // store.value = 'light'
        modeModelValue.value = false
    }

    if (store.value === 'dark') {
        modeModelValue.value = true
    }
}

const onToggle = (payload: boolean) => {
    if (payload === true) {
        store.value = 'dark'
        modeModelValue.value = true
    } else {
        store.value = 'light'
        modeModelValue.value = false
    }
}

export const useMsigColorMode = () => {
    return {
        store,
        modeModelValue,
        onToggle
    }
}